module.exports = __webpack_public_path__ + "static/media/app1.76e88658.png";